<template lang="pug">
  div.myChartDiv
    canvas(id="myChart")
</template>

<script>

import Chart from 'chart.js'
import 'chartjs-plugin-zoom'

export default {
  name: 'PluginZoomChart',
  data () {
    return {
      colorCurrentYear: '#2E6C99',
      chart: []
    }
  },
  props: {
    dataChart: {
      type: Object
    }
  },
  methods: {
    createChart () {
      const vm = this
      let series = []
      var ctx = document.getElementById('myChart')
      vm.dataChart.series[0].forEach(item => {
        series.push(item.value)
      })
      var myChart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: vm.dataChart.labels,
          datasets: [
            {
              label: '',
              borderColor: this.colorCurrentYear,
              backgroundColor: this.colorCurrentYear,
              radius: 4,
              pointBackgroundColor: this.colorCurrentYear,
              pointHoverRadius: 4,
              pointHoverBackgroundColor: this.colorCurrentYear,
              fill: false,
              data: series
            }
          ]
        },
        options: {
          scales: {
            xAxes: [{
              gridLines: {
                drawBorder: false,
                display: false
              }
            }],
            yAxes: [{
              /*
              gridLines: {
                drawBorder: false,
                display: false
              },
              */
              ticks: {
                beginAtZero: true,
                stepSize: 10
              }
            }]
          },
          legend: {
            display: false
          },
          plugins: {
            zoom: {
              // Container for pan options
              pan: {
                // Boolean to enable panning
                enabled: true,

                // Panning directions. Remove the appropriate direction to disable
                // Eg. 'y' would only allow panning in the y direction
                mode: 'xy'
              },
              // Container for zoom options
              zoom: {
                // Boolean to enable zooming
                enabled: true,

                // Zooming directions. Remove the appropriate direction to disable
                // Eg. 'y' would only allow zooming in the y direction
                mode: 'xy'
              }
            }
          }
        }
      })
      if (!myChart) {
        alert(myChart)
      }
    }
  },
  mounted () {
    this.createChart()
  }
}
</script>

<style lang="scss" scoped>
  #myChart {
    width: 100% !important;
    height: 50% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/PluginZoomChart.vue